import React from 'react';
import './css/documenCard.scss';

import dayjs from 'dayjs';
import LazyImage from '../../../../components/CustomLibraries/LazyImage';
import { FiDownload } from '../../../../components/icons';
import { downloadFromUrl } from '../../../../common/common';

const DocumentCard = ({ data }) => {
  return (
    <div
      className="w-100 documentCardV1Box bg-white rounded cursorPointer shadow position-relative overflow-hidden"
      onClick={() => {
        if (data?.original_file) {
          window.open(data?.original_file);
          // downloadFromUrl(data?.original_file, data?.document_name);
        }
      }}
    >
      <img src={data?.thumbnail_image} className="w-100 h-auto" alt="document" />
      <div className="overlay z-1"></div>
      <div className="documentCardV1Content text-start position-absolute bottom-0 w-100 p-4 z-1">
        <div className="d-flex justify-content-between">
          <div className="z-2">
            <h2 className="text-white fs-4 fw-normal mb-1 line-clamp-1">
              {data?.document_name?.length > 50
                ? data?.document_name?.split(0, 50)
                : data?.document_name}
            </h2>
            <h5 className="text-white fs-5 fw-normal">
              {data?.added_on != null && dayjs(data?.added_on).format('DD MMMM, YYYY')}
            </h5>
          </div>

          <button
            className="rounded py-2 px-5 btn btn-secondary fs-4 rounded"
            aria-label="Download"
          >
            Open
          </button>
        </div>
      </div>
    </div>
  );
};

export default DocumentCard;
